@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
} @else {
  <app-summary-cards [cards]="adminCards"></app-summary-cards>

  <div class="search-add-button-container">
    <input
    inputmode="search"
    role="searchbox"
    type="search"
    name="search"
    class="search-box"
    placeholder="Search users..."
    [(ngModel)]="searchQuery"
    (input)="filterUsers()"
  />

  <button class="add-user-button" (click)="openAddUserModal()">Add User</button>
  </div>

  <div class="desktop-user-table-view">
    <div class="table-container">
      <table class="user-table">
        <thead>
          <tr>
            <th>User</th>
            <th (click)="sortBy('userRole')" class="sortable">
              User Type
              <i
                *ngIf="sortColumn === 'userRole'"
                class="bi"
                [ngClass]="getSortIcon('userRole')"
              ></i>
            </th>
            <th>Donors Assigned</th>
            <th>In Referral</th>
            <th>Under Evaluation</th>
            <th>Awaiting MRB</th>
            <th (click)="sortBy('enabled')" class="sortable">
              Status
              <i
                *ngIf="sortColumn === 'enabled'"
                class="bi"
                [ngClass]="getSortIcon('enabled')"
              ></i>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of paginatedUsers">
            <td class="user-info-row">
              <div class="user-info-container">
                <img src="placeholder_profile.png" class="avatar" />
                <div class="user-details">
                  <p class="name">{{ user.firstName }} {{ user.lastName }}</p>
                  <p class="email">{{ user.email }}</p>
                </div>
              </div>
            </td>
            <td>{{ user.userRole }}</td>
            <td>{{ user.donorCount && user.donorCount > 0 ? user.donorCount : '0' }}</td>
            <td>{{ user.inReferralCount && user.inReferralCount  > 0 ? user.inReferralCount : '0' }}</td>
            <td>{{ user.underEvalCount && user.underEvalCount > 0 ? user.underEvalCount : '0' }}</td>
            <td>{{ user.awaitingMRBCount && user.awaitingMRBCount > 0 ? user.awaitingMRBCount : '0' }}</td>
            <td>
              <span
                class="status-badge"
                [ngClass]="{
                  active: user.enabled,
                  inactive: !user.enabled
                }"
              >
                {{ user.enabled ? "Active" : "Inactive" }}
              </span>
            </td>
            <td>
              <button class="icon-button" (click)="openAssignedDonorsModal(user)"><i class="bi bi-people"></i></button>
              <button class="icon-button" (click)="openUserProfile(user)">
                <i class="bi bi-info-circle"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="mobile-user-cards-view">
    <div class="mobile-user-cards">
      <article class="user-card" *ngFor="let user of paginatedUsers">
        <div class="user-card-header">
          <img src="placeholder_profile.png" class="avatar" />
          <div class="user-card-header-text">
            <p class="name">{{ user.firstName }} {{ user.lastName }}</p>
            <p class="email">{{ user.email }}</p>
          </div>
        </div>

        <div class="user-card-row">
          <span class="user-card-label">User Type</span>
          <span class="user-card-value">{{ user.userRole }}</span>
        </div>

        <div class="user-card-grid">
          <div class="user-stat-card">
            <span class="user-card-label">Donors Assigned</span>
            <span class="user-card-value">{{ user.donorCount && user.donorCount > 0 ? user.donorCount : '0' }}</span>
          </div>
          <div class="user-stat-card">
            <span class="user-card-label">In Referral</span>
            <span class="user-card-value">{{ user.inReferralCount && user.inReferralCount  > 0 ? user.inReferralCount : '0' }}</span>
          </div>
          <div class="user-stat-card">
            <span class="user-card-label">Under Evaluation</span>
            <span class="user-card-value">{{ user.underEvalCount && user.underEvalCount > 0 ? user.underEvalCount : '0' }}</span>
          </div>
          <div class="user-stat-card">
            <span class="user-card-label">Awaiting MRB</span>
            <span class="user-card-value">{{ user.awaitingMRBCount && user.awaitingMRBCount > 0 ? user.awaitingMRBCount : '0' }}</span>
          </div>
        </div>

        <div class="user-card-row">
          <span class="user-card-label">Status</span>
          <span
            class="status-badge"
            [ngClass]="{
              active: user.enabled,
              inactive: !user.enabled
            }"
          >
            {{ user.enabled ? "Active" : "Inactive" }}
          </span>
        </div>

        <div class="user-card-actions">
          <button class="mobile-action-button" (click)="openAssignedDonorsModal(user)">
            Assigned Donors
          </button>
          <button class="icon-button mobile-icon-button" (click)="openUserProfile(user)">
            <i class="bi bi-info-circle"></i>
          </button>
        </div>
      </article>
    </div>
  </div>
  <div class="pagination-controls-wrapper" *ngIf="filteredUsers.length > 0">
    <div class="pagination-controls-row">
      <div class="pagination-stack">
        <div class="pagination-controls">
          <button
            class="pagination-button pagination-nav"
            (click)="setPage(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            <i class="bi bi-chevron-left"></i>
            Back
          </button>
          <ng-container *ngIf="totalPages > 1">
            <ng-container *ngFor="let item of paginationItems">
              <button
                *ngIf="item !== 'ellipsis'; else paginationEllipsis"
                class="pagination-button pagination-page"
                (click)="setPage(+item)"
                [class.active]="currentPage === item"
              >
                {{ item }}
              </button>
              <ng-template #paginationEllipsis>
                <span class="pagination-ellipsis">...</span>
              </ng-template>
            </ng-container>
          </ng-container>
          <button
            class="pagination-button pagination-nav"
            (click)="setPage(currentPage + 1)"
            [disabled]="currentPage === totalPages"
          >
            Next
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
        <div class="pagination-summary">
          {{ pageRangeStart }}-{{ pageRangeEnd }} of {{ filteredUsers.length }}
        </div>
      </div>

      <div class="page-size-controls">
        <label for="user-table-page-size">Result per page</label>
        <select
          id="user-table-page-size"
          class="form-select form-select-sm"
          [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)"
        >
          <option *ngFor="let option of pageSizeOptions" [ngValue]="option">
            {{ option === 0 ? "All" : option }}
          </option>
        </select>
      </div>
    </div>
  </div>
}
